import { resolveSchemaFieldOptions } from '@/lib/schemaFieldOptions';
import store from '@/store';

/**
 * Apply dynamic schema resolution (optionsFrom, etc.) before passing to a field component.
 *
 * @param {Object} fieldSchema
 * @param {Object} context
 * @param {Object} [context.instance] Sibling field values (nested row or form model)
 * @param {Object} [context.store] Vuex store
 * @param {string} [context.fieldKey] Field key being rendered
 * @param {Object} [context.optionsContext] Optional overrides from extendedFieldSchema
 */
export function resolveFormFieldSchema(fieldSchema, context = {}) {
  if (!fieldSchema) {
    return fieldSchema;
  }

  const resolved = { ...fieldSchema };

  if (fieldSchema.optionsFrom) {
    resolved.options = resolveSchemaFieldOptions(fieldSchema, context);
  }

  return resolved;
}

/**
 * Returns false when showOnHavingTruthy fields are not set on instance.
 */
export function passesShowOnHavingTruthy(fieldSchema, instance) {
  const truthyFields = fieldSchema?.showOnHavingTruthy;
  if (!Array.isArray(truthyFields) || !truthyFields.length) {
    return true;
  }

  if (!instance) {
    return false;
  }

  return truthyFields.every((key) => Boolean(instance[key]));
}

/**
 * Returns false when the sibling contact field (lesson `contact_field`, automation `field`)
 * is not of the showOnContactFieldType type.
 */
export function passesShowOnContactFieldType(fieldSchema, instance) {
  const type = fieldSchema?.showOnContactFieldType;
  if (!type) {
    return true;
  }

  const getSingleField = store.getters['fields/getSingleField'];
  return (
    getSingleField(instance?.contact_field ?? instance?.field)?.type === type
  );
}

export function getSchemaInstanceContext(item, meta) {
  return meta?.parentInstance ?? item?.values ?? null;
}
